export default __webpack_public_path__ + "static/media/A pay.63ef0d05.svg";